/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Rating system used for ladder rankings
 * @export
 */
export const RankingSystem = {
    ELO: 'ELO',
    GLICKO: 'GLICKO',
    TRUESKILL: 'TRUESKILL',
    SIMPLE: 'SIMPLE'
} as const;
export type RankingSystem = typeof RankingSystem[keyof typeof RankingSystem];


export function instanceOfRankingSystem(value: any): boolean {
    for (const key in RankingSystem) {
        if (Object.prototype.hasOwnProperty.call(RankingSystem, key)) {
            if (RankingSystem[key as keyof typeof RankingSystem] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RankingSystemFromJSON(json: any): RankingSystem {
    return RankingSystemFromJSONTyped(json, false);
}

export function RankingSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankingSystem {
    return json as RankingSystem;
}

export function RankingSystemToJSON(value?: RankingSystem | null): any {
    return value as any;
}

export function RankingSystemToJSONTyped(value: any, ignoreDiscriminator: boolean): RankingSystem {
    return value as RankingSystem;
}

